'use client';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useChatbotOpen } from '@/components/chatbot/use-chatbot-open';
import { useScroll } from '@/utils/use-scroll';
import MainBar from './main-bar';
import './style.css';
import SubMenu from './mega-menu/sub-menu';
interface Props {
  className?: string;
}
function HeaderContent({
  className
}: Props) {
  const [isGoftinoOpen, setGoftinoOpen] = useState(false);
  const {
    isChatOpen
  } = useChatbotOpen();
  const {
    isScrollingUp,
    scrollY
  } = useScroll();
  useEffect(() => {
    const onOpen = () => setGoftinoOpen(true);
    const onClose = () => setGoftinoOpen(false);
    window.addEventListener('goftino_openWidget', onOpen);
    window.addEventListener('goftino_closeWidget', onClose);
    return () => {
      window.removeEventListener('goftino_openWidget', onOpen);
      window.removeEventListener('goftino_closeWidget', onClose);
    };
  }, []);

  // eslint-disable-next-line no-nested-ternary
  const topOfGoftinoClass = isGoftinoOpen ? 'z-header' : isChatOpen ? 'z-artin-header' : 'z-top-of-chatbot-plus1';
  return <header id='header' className={classNames('sticky top-0 w-full bg-white px-2 py-3 shadow-sm transition-all duration-500 lg:p-0', topOfGoftinoClass, className, {
    'lg:relative': !isScrollingUp
  }, {
    slideInDown: isScrollingUp && scrollY > 700
  })} data-sentry-component="HeaderContent" data-sentry-source-file="header-content.tsx">
            <MainBar data-sentry-element="MainBar" data-sentry-source-file="header-content.tsx" />
            <SubMenu data-sentry-element="SubMenu" data-sentry-source-file="header-content.tsx" />
        </header>;
}
export default HeaderContent;